import { createSlice } from '@reduxjs/toolkit';
import resolveApplication from '@fogia/core-web/state/application/resolve';
import { camelCaseMapValues } from '@fogia/core-web/utils/camelCaseMapValues';

export type ReferencesState = Record<string, unknown>;

const initialState: ReferencesState = {};

const slice = createSlice({
    name: 'references',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(resolveApplication.fulfilled, (_, { payload }) => {
            const dataFromPayload = (payload?.data?._references ?? {}) as Record<string, unknown>;
            return camelCaseMapValues(dataFromPayload) as ReferencesState;
        });
    },
});

export const { reducer } = slice;
